module.exports = __webpack_public_path__ + "images/emoji/astonished.54003d52db6de8524ce3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/astonished.png
// module id = pJAJ
// module chunks = 1